<template>
    <div class="reservateMeeting">
        <div class="book-meeting">
            <span @click="goMeetingList" class="meeting-arrow"></span>
            新建案件
        </div>
        <div class="meeting-type">
            <el-form class="first-form" label-width="120px" :model="caseTypeform" ref="typeform" :rules="rules" @submit.native.prevent>
                <el-row style="padding-top: 15px">
                    <el-form-item prop="type" label="案件类型：">
                        <el-radio-group v-model="caseTypeform.type" @change="caseTypeChanged">
                            <el-radio v-for="(type, singleType) in caseTypeList" :key="singleType" :label="type.value">{{type.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item prop="name" label="案号：" v-if="caseTypeform.type == case_type_code.MEDIATION_MEETING">
                            <el-input v-model="caseTypeform.name" placeholder="请输入会议主题" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item prop="caseNo" label="案号：" v-else>
                            <el-input v-model="caseTypeform.caseNo" placeholder="请输入案号" maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="案由：" prop="cause">
                            <el-select v-model="caseTypeform.cause" placeholder="请选择案由" style="width: 100%">
                                <el-option
                                        v-for="item in causeOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="caseTypeform.type !== case_type_code.MEDIATION_MEETING">
                    <el-col :span="8">
                        <el-form-item label="书记员：" prop="clerk">
                            <el-select v-model="caseTypeform.clerk" placeholder="请选择书记员" style="width: 100%">
                                <el-option
                                        v-for="item in clerkOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="仲裁员：" prop="mediator">
                            <el-select v-model="caseTypeform.mediator" placeholder="请选择仲裁员" style="width: 100%">
                                <el-option
                                        v-for="item in mediatorOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="meeting-type" v-if="caseTypeform.type == case_type_code.MEDIATION_MEETING">
            <div class="type-tittle">
                <span>会议时间</span>
            </div>
            <el-form class="first-form" :model="timeform" ref="timeform" :rules="rules" label-width="0">
                <el-form-item label-width="50px">
                    <el-radio-group v-model="timeform.type">
                        <el-radio
                            v-for="(type, singleType) in bookList"
                            :key="singleType"
                            :label="type.code">
                            {{type.name}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-row class="book-time-date"  type="flex" justify="flex-start">
                    <el-col :span="11">
                        <el-form-item label="预约日期" label-width = "120px" prop="orderDate">
                            <el-date-picker
                                v-model="timeform.orderDate"
                                :picker-options = "disabledDateOptions"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy/MM/dd"
                                class="width240"
                                :disabled="datePickerStatus">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item prop="orderNewTime" label-width = "0">
                            <el-time-picker
                                v-model="timeform.orderNewTime"
                                placeholder="选择时间点"
                                :picker-options = "disabledTimeOptions"
                                value-format = "HH:mm"
                                class="width240"
                                @focus="currentTime"
                                :disabled="datePickerStatus">
                            </el-time-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="relation-meterail" v-if="caseTypeform.type == case_type_code.MEDIATION_MEETING">
            <div class="type-tittle">
                <span>相关材料（文件大小不大于10M，支持上传{{acceptType.replace(/,/g, '、')}}文件）</span>
            </div>
            <el-form class="file-form" :model="allFile" :rules="rules" ref="allFile" label-width="90px">
                <el-row
                    v-for="(ff, ffindex) in allFile.fileform"
                    :key="ffindex"

                    type="flex"
                    justify="space-between"
                    :class="{'disabled': !ff.showDelete}">
                    <el-col :span="5">
                        <el-form-item label="角色：">
                            <el-select v-model="ff.categorySmall" class="widthauto" placeholder="请选择" >
                                <el-option v-for="item in roleOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="材料分类：">
                            <el-select :disabled="ff.disableFlag" v-model="ff.categoryBig" @change="changefiletype($event, ffindex)" class="widthauto" placeholder="请选择" >
                                <el-option
                                    v-for="(filetype, ftindex) in filetypelist"
                                    :key="ftindex"
                                    :label="filetype.name"
                                    :value="filetype.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="材料名称：" :prop="'fileform.' + ffindex + '.remark'"  :rules="{ message: '请输入材料名称', trigger: 'blur'}" >
                            <el-input :disabled="ff.disableFlag" v-model="ff.remark" placeholder="请输入材料名称" class="widthauto"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="材料附件：">
                            <el-upload
                                :disabled="ff.disableFlag"
                                class="fileupload"
                                :action="actionUrl"
                                :data="uploaddata"
                                :accept="acceptType"
                                :headers="flk"
                                :on-success="(...args) => filesuccess(...args, ffindex)"
                                :on-remove="(...args) => fileremove(...args, ffindex)"
                                :before-upload="(...args) => handleBefore(...args, acceptType, ff)"
                                :limit="1"
                                :file-list="ff.filelist">
                                <el-button size="small" type="primary" v-show="ff.filelist.length === 0"><i></i>点击上传文件</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" :class="{hidden: !ff.showDelete}" >
                        <div class="icon-name" @click="delfileform(ffindex)" >
                            <i class="el-icon-delete" ></i><span class="delete-name">&nbsp;&nbsp;删除</span>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
            <div class="filebox-addtips">
                <p class="addfile" @click="addfileform">
                    <el-button type="primary" plain icon="el-icon-plus">新增材料</el-button>
                </p>
            </div>
        </div>
        <div class="attendant-number">
            <div class="type-tittle">
                <span v-if="caseTypeform.type == case_type_code.MEDIATION_MEETING">参会人员（最多支持8个参会人员） </span>
                <span v-else>当事人</span>
                <el-button type="text" plain style="float:right; border: none; padding: 0 20px" @click="showImportDialog(1)">
                    <span style="color: #0083c8; font-size: 14px; line-height: 50px">导入</span>
                </el-button>
            </div>
            <el-form :model="allMember" class="attendant-form" :rules="rules" ref="allMember" label-width="120px">
                <el-row v-for="(ff, ffindex) in allMember.attendantform" :key="ffindex" class="member_item">
                    <el-col :span="23">
                        <el-row style="display: flex">
                            <el-form-item :prop="'attendantform.' + ffindex + '.meetingUserType'" :rules="{required: true, message: '请选择身份类型', trigger: 'change'}" label="身份类型：" style="max-width: 25%">
                                <el-select v-model="ff.meetingUserType" placeholder="请选择身份类型" value-key="value" style="width: 100%">
                                    <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                                        <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-option-group>
<!--                                    <el-option v-for="item in meetingTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
                                </el-select>

                            </el-form-item>
                            <template v-if="ff.meetingUserType && ff.meetingUserType.indexOf('COMPANY') == -1">
                                <el-form-item :prop="'attendantform.' + ffindex + '.userName'" :rules="{required: true, message: '请输入姓名', trigger: 'blur'}" label="姓名：">
                                    <el-input v-model.trim="ff.userName" placeholder="请输入姓名"  class="widthauto"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'attendantform.' + ffindex + '.idCard'" :rules="rules.idCard" label="身份证号：">
                                    <el-input v-model.trim="ff.idCard" placeholder="请输入身份证号"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'attendantform.' + ffindex + '.mobilePhone'" :rules="[{required: true, message: '请输入手机号', trigger: 'blur'},
                            { pattern: /^1[3-9]\d{9}$/, message: '手机号输入不正确', trigger: 'blur'}
                            ]" label="手机：">
                                    <el-input v-model="ff.mobilePhone" maxlength="11" placeholder="请输入手机号" class="widthauto"></el-input>
                                </el-form-item>
                            </template>
                            <template  v-if="ff.meetingUserType && ff.meetingUserType.indexOf('COMPANY') > -1">
                                <el-form-item :prop="'attendantform.' + ffindex + '.conName'" :rules="{required: true, message: '请输入企业名称', trigger: 'blur'}" label="企业名称：">
                                    <el-input v-model.trim="ff.conName" placeholder="请输入企业名称"  class="widthauto"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'attendantform.' + ffindex + '.legalPerson'" :rules="rules.legalPerson" label="法定代表人：">
                                    <el-input v-model.trim="ff.legalPerson" placeholder="请输入法定代表人姓名"></el-input>
                                </el-form-item>
                                <el-form-item :prop="'attendantform.' + ffindex + '.address'" :rules="{required: true, message: '请输入住所', trigger: 'blur'}" label="住所：">
                                    <el-input v-model="ff.address" placeholder="请输入住所"  class="widthauto"></el-input>
                                </el-form-item>
                            </template>
                        </el-row>
                        <el-row style="display: flex; margin-top: 20px" v-if="ff.meetingUserType == 'APPLICANT_AGENT' || ff.meetingUserType == 'RESPONDENT_AGENT'" >
                            <el-form-item :prop="'attendantform.' + ffindex + '.agentPosition'" :rules="{required: true, message: '请选择代理类型', trigger: 'change'}" label="代理类型：" style="width: 25%">
                                <el-select v-model="ff.agentPosition" placeholder="请选择代理类型" value-key="value" style="width: 100%">
                                    <el-option
                                            v-for="item in agentPositionOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item :prop="'attendantform.' + ffindex + '.agentAddress'" :rules="{required: true, message: '请输入所在单位', trigger: 'blur'}" label="所在单位：" style="width: 75%">
                                <el-input v-model="ff.agentAddress" placeholder="请输入所在单位"  class="widthauto"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row style="display: flex; margin-top: 20px"  v-else-if="ff.meetingUserType && ff.meetingUserType.indexOf('COMPANY') == -1">
                            <el-form-item label="民族：" :prop="'attendantform.' + ffindex + '.minority'" :rules="{required: true, message: '请选择民族', trigger: 'change'}">
                                <el-select v-model="ff.minority" placeholder="请选择民族" value-key="value" style="width: 100%">
                                    <el-option v-for="item in minorityList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="性别：" :prop="'attendantform.' + ffindex + '.sex'" :rules="{required: true, message: '请选择性别', trigger: 'change'}">
                                <el-select v-model="ff.sex" placeholder="请选择性别" value-key="value" style="width: 100%">
                                    <el-option label="男" value="男"/>
                                    <el-option label="女" value="女"/>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="生日：" :prop="'attendantform.' + ffindex + '.birth'" :rules="{required: true, message: '请选择生日', trigger: 'change'}">
                                <el-date-picker type="date" placeholder="请选择生日" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="ff.birth" style="width: 100%"></el-date-picker>
                            </el-form-item>
                            <el-form-item :prop="'attendantform.' + ffindex + '.address'" :rules="{required: true, message: '请输入身份证上住址', trigger: 'blur'}" label="身份证上住址：">
                                <el-input v-model="ff.address" placeholder="请输入身份证上住址"  class="widthauto"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row v-if="ff.meetingUserType == 'APPLICANT' || ff.meetingUserType == 'APPLICANT_COMPANY'" style="margin-top: 20px">
                            <el-form-item :prop="'attendantform.' + ffindex + '.arbitrationClaim'" :rules="rules.arbitrationClaim" label="仲裁请求：" style="width: 100%">
                                <el-input v-model="ff.arbitrationClaim" type="textarea" :rows="3" maxlength="2000" show-word-limit placeholder="请输入仲裁请求"></el-input>
                            </el-form-item>
                        </el-row>
                    </el-col>
                    <el-col :span="1" :class="{hidden: !ff.showDelete}" style="text-align: center">
                        <span v-if ="allMember.attendantform.length >1" class="icon-name" @click="delAttendant(ffindex)" >
                            <i class="el-icon-delete" ></i>
                        </span>
                    </el-col>
                </el-row>
            </el-form>
            <div class="filebox-addtips" style="margin-top: 20px">
                <p class="addfile" @click="addAttendant">
                    <el-button type="primary" plain icon="el-icon-plus">新增{{caseTypeform.type == case_type_code.MEDIATION_MEETING ? '参会人员': '当事人'}}</el-button>
                </p>
            </div>
        </div>
        <div class="questions-list"  v-show="caseTypeform.type == case_type_code.ASYNCHRONOUS_TRIAL">
            <div class="type-tittle">
                <span>问题单</span>
            </div>
            <div style="padding-top: 20px">
                <el-checkbox-group v-model="checkedQuestions" style="margin-left:50px">
                    <el-checkbox v-for="question in embedQuestion" :label="question" :key="question.id" style="width:800px; height:50px" checked disabled>
                        <el-input disabled v-model="question.sort" style="width:60px;margin-right:20px;" placeholder="序号"></el-input>
                        <el-input disabled v-model="question.questionContent" style="width:300px;"></el-input>
                    </el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-model="checkedQuestions" style="margin-left:50px">
                    <el-checkbox v-for="(question,index) in questionList" :label="question" :key="question.id" style="width:800px; height:50px" :checked="checkedArr[index]"  @change="checked=>singleBoxChange(checked, index)">
                        <el-input :disabled="!checkedArr[index]" v-model="question.sort" style="width:60px;margin-right:20px;" placeholder="序号"></el-input>
                        <el-input :disabled="!checkedArr[index]" v-model="question.addText" style="width:300px;margin-right:20px;"></el-input>
                        <el-input :disabled="true" v-model="question.questionContent" style="width:300px;"></el-input>
                    </el-checkbox>
                </el-checkbox-group>
                <div class="custom-questions">
                    <div class="custom-question" v-for="(item, index) in customQuestionList" :key="index">
                        <el-input  v-model="item.sort" style="width:60px;margin-left:10px;margin-right:10px;" placeholder="序号"></el-input>
                        <el-input class="input" v-model="item.text" placeholder="请输入内容" maxlength='400'></el-input>
                        <i class="el-icon-delete icon" style="color:#1e6dcb" @click="deleteCustomQuestion(index)"></i>
                    </div>
                </div>
                <div style="width: 100%; margin-top: 20px">
                    <div class="filebox-addtips" style="display: flex; justify-content: center">
                        <p class="addfile" @click="addCustomQuestion" style="width: 120px; margin: 0 50px 0 0">
                            <el-button type="primary" plain icon="el-icon-plus">新增问题</el-button>
                        </p>
                        <p class="addfile" style="width: 120p; margin: 0" @click="showImportDialog(2)">
                            <el-button type="primary" plain icon="el-icon-plus">批量导入</el-button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="sumbmit-form">
                <div  @click="submitAllForm" class="sumbit">提交</div>
                <div @click="goMeetingList" class="concel">取消</div>
            </div>
        </div>
        <el-dialog class="doc_send_dialog" :title="importType == 1? '导入当事人':'导入问题单'" width="600px" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" center>
            <div style="padding: 0 95px">
                <el-upload
                        drag
                        class="fileupload"
                        :action="actionUrl"
                        :data="uploaddata"
                        :accept="acceptExcelType"
                        :headers="flk"
                        :file-list="importFilelist"
                        :on-success="uploadSuccess"
                        :on-exceed="handleExceed"
                        :limit="1"
                        :before-upload="(...args) => handleBefore(...args, acceptExcelType)">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">只能上传xls、xlsx文件，且不超过10MB</div>
                </el-upload>
                <el-button type="text" style="margin-top: 10px" @click="downloadTemplateFile">模板下载</el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button :loading="BtnLoading" @click="closeImportDialog">取 消</el-button>
                <el-button type="primary" :loading="BtnLoading" @click="handleImport()">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {addMeeting,getMaterailInfo,getCaseEnvCase} from '@/api/meeting'
import {listBackstageUser} from "../../api/user";
import {ERR_OK} from '@/api/reConfig'
// import uploadfile from '@/components/uploadfile'
import { setStore, getStore, removeStore, getStoreSession } from '@/utils/utils.js'
import config from '@/config/config.js'
import {getEnvCase, analysisExcel, addmediationMeeting, addAsynchronousMeeting, queryNations, analysisPersonExcel} from '@/api/case.js'
import {getDefalutQuestionListApi} from "../../api/question_list";
import filedownload from '@/api/filedown.js'
import {maxFileLength, maxFileWarning, CASE_TYPE_DICTIONARY, CASE_TYPE_CODE, dateformat} from "../../utils/utils";

export default {
    data() {
        var validateId = (rule, value, callback) => {
            var myreg = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
            if (value) {
                if (!myreg.test(value)) {
                    callback(new Error('身份证格式不正确'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        return {
            dialogVisible: false,
            importType: 0,
            importFilelist: [],
            BtnLoading: false,
            datePickerStatus:true,
            actionUrl: `${config.baseURL}/basicGateway/file/upload`,
            acceptType: '.doc,.docx,.pdf,.png,.jpg,.jpeg',
            acceptExcelType: '.xls,.xlsx',
            questionFiles: [],
            flk: {JWTToken: '', appName: 'gzzc',cType:'PC'},
            uploaddata: {
                isView: 'NOVIEW'
            },
            case_type_code: CASE_TYPE_CODE,
            caseTypeform:{
                type: "ASYNCHRONOUS_TRIAL",
                meetingType: 'MEETING_JOINT',
                name: "",
                caseNo: "",
                cause: "",
                clerk: "",
                mediator: ""
            },
            typeform:{
                type:"MEETING_JOINT",
                name:""
            },
            timeform:{
                type:"IMMEDIATELY_TYPE",
                date:"",
                orderDate:'',
                orderNewTime:'',
            },
            allFile:{
                fileform: [
                    {
                        categoryBig: '',  //材料分类的名称
                        categoryMiddle: '',
                        categorySmall: '',
                        remark: '',
                        showDelete: true,   // 是否显示删除按钮
                        filelist:[],// 材料名称
                        disableFlag:false,
                    }
                ]
            },
            allMember:{
                attendantform:[]
            },
            causeOptions: [
                {
                    value: '1',
                    label: '劳动报酬'
                },{
                    value: '2-1',
                    label: '工伤保险'
                }, {
                    value: '2-2',
                    label: '养老保险'
                }, {
                    value: '2-3',
                    label: '社会保险'
                }, {
                    value: '3',
                    label: '确认劳动关系'
                }, {
                    value: '4',
                    label: '解除、终止劳动合同'
                }, {
                    value: '6',
                    label: '履行聘用合同'
                }, {
                    value: '7',
                    label: '解除人事关系'
                }, {
                    value: '8',
                    label: '其他'
                }
            ],
            clerkOptions: [],
            mediatorOptions: [],
            roleOptions: [{
                value: 'APPLICANT',
                label: '申请人',
            },{
                value: 'RESPONDENT',
                label: '被申请人',
            },{
                value: 'MEDIATOR',
                label: '仲裁员',
            }
            ],
            minorityList: [{
                value: '汉族',
                label: '汉族',
            }],
            caseTypeList: CASE_TYPE_DICTIONARY,
            typeList:[{
                name:"联席会议",
                code:"MEETING_JOINT"
                },{
                name:"磋商会议",
                code:"MEETING_ONLINE"
                }
            ],
            bookList:[{
                name:"预约时间",
                code:"ORDER_TYPE"
                },{
                name:"立即开始",
                code:"IMMEDIATELY_TYPE"
                }
            ],
            filetypelist: [
                {
                    value: 'IDENTITY_CERTIFICATE',
                    label: '身份证明'
                },{
                    value: 'EVIDENCE_INVENTORY',
                    label: '证据清单'
                },{
                    value: 'OTHER',
                    label: '其他'
                },{
                    value: 'DOCUMENT_MATERIAL',
                    label: '文书材料'
                }
            ],
            options: [{
                label: '申请人',
                options: [{
                    value: 'APPLICANT',
                    label: '申请人 - 劳动者'
                }, {
                    value: 'APPLICANT_COMPANY',
                    label: '申请人 - 企业'
                },]
            }, {
                label: '被申请人',
                options: [{
                    value: 'RESPONDENT',
                    label: '被申请人 - 劳动者'
                }, {
                    value: 'RESPONDENT_COMPANY',
                    label: '被申请人 - 企业'
                }]
            }, {
                label: '',
                options: [{
                    value: 'APPLICANT_AGENT',
                    label: '申请人代理人'
                },{
                    value: 'RESPONDENT_AGENT',
                    label: '被申请人代理人'
                },{
                    value: 'OTHER',
                    label: '其他人'
                }]
            }],
            meetingTypeList: [{
                value: 'APPLICANT',
                label: '申请人'
            }, {
                value: 'APPLICANT_COMPANY',
                label: '申请人'
            }, {
                value: 'RESPONDENT',
                label: '被申请人'
            }, {
                value: 'RESPONDENT_COMPANY',
                label: '被申请人'
            }, {
                value: 'APPLICANT_AGENT',
                label: '申请人代理人'
            }, {
                value: 'RESPONDENT_AGENT',
                label: '被申请人代理人'
            }, {
                value: 'OTHER',
                label: '其他人'
            }],
            agentPositionOptions: [
                {
                    value: '普通律师代理',
                    label: '普通律师代理'
                }, {
                    value: '法援律师代理人',
                    label: '法援律师代理人'
                },{
                    value: '近亲属代理',
                    label: '近亲属代理'
                },{
                    value: '一般公民代理',
                    label: '一般公民代理'
                },{
                    value: '职务代理',
                    label: '职务代理'
                },{
                    value: '其他代理',
                    label: '其他代理'
                }
            ],
            rules: {
                type: [
                    { required: true, trigger: 'blur' },
                ],
                clerk: [
                    { required: true, message: '请选择书记员', trigger: 'change' },
                ],
                mediator: [
                    { required: true, message: '请选择仲裁员', trigger: 'change' },
                ],
                caseNo: [
                    { required: true, message: '请输入20字以内的案号', trigger: 'blur' }
                ],
                conName: [
                    { required: true, message: '请输入企业名称', trigger: 'blur' }
                ],
                legalPerson: [
                    { required: true, message: '请输入法定代表人姓名', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入20字以内的会议主题', trigger: 'blur' }
                ],
                idCard: [{
                        required: true,
                        message: '请输入居民身份证号码',
                        trigger: 'blur'
                    },
                    {
                        validator: validateId,
                        trigger: 'blur'
                    } //身份证
                ],
            },
            disabledDateOptions: {
                disabledDate(time) {
                    return time.getTime() < (new Date().getTime()-3600*24*1000);
                }
            },
            disabledTimeOptions:{},
            getInfo:[],
            id: null, // 智慧仲裁案件id
            questionList: [],
            checkedArr: [],
            checkedQuestions: [],
            customQuestionList: [{ text: '' }],
            embedQuestion: [{
                    sort: '1',
                    questionContent: "被申请人答辩",
                    questionType: 21
                },
                {
                    sort: '101',
                    questionContent: "双方当事人对事实部分还有无补充？",
                    questionType: 22
                }, {
                    sort: '102',
                    questionContent: "最后陈述意见",
                    questionType: 20
                }, {
                    sort: '103',
                    questionContent: "是否愿意调解？",
                    questionType: 12
                }
            ]
       }
    },
    watch: {
        'timeform.type': function (newData, oldData) {
            if (newData == 'IMMEDIATELY_TYPE') {
                this.datePickerStatus = true
            } else if ( newData == 'ORDER_TYPE') {
                this.datePickerStatus = false
            }
        },

    },
    created() {
        this.getData()
        this.getMaterailInfo()
        this.addAttendant()
        this.allFile.fileform = []
    },
    mounted() {
    },
    methods: {
        caseTypeChanged(val) {
            if (val == 'MEDIATION_MEETING') {
                this.options = [{
                label: '',
                options: [{
                    value: 'APPLICANT',
                    label: '申请人'
                }, {
                    value: 'RESPONDENT',
                    label: '被申请人'
                }, {
                    value: 'APPLICANT_AGENT',
                    label: '申请人代理人'
                }, {
                    value: 'RESPONDENT_AGENT',
                    label: '被申请人代理人'
                }, {
                    value: 'OTHER',
                    label: '其他人'
                }]
                }]
            } else {
                this.options = [{
                    label: '申请人',
                    options: [{
                        value: 'APPLICANT',
                        label: '申请人 - 劳动者'
                    }, {
                        value: 'APPLICANT_COMPANY',
                        label: '申请人 - 企业'
                    },]
                }, {
                    label: '被申请人',
                    options: [{
                        value: 'RESPONDENT',
                        label: '被申请人 - 劳动者'
                    }, {
                        value: 'RESPONDENT_COMPANY',
                        label: '被申请人 - 企业'
                    }]
                }, {
                    label: '',
                    options: [{
                        value: 'APPLICANT_AGENT',
                        label: '申请人代理人'
                    },{
                        value: 'RESPONDENT_AGENT',
                        label: '被申请人代理人'
                    },{
                        value: 'OTHER',
                        label: '其他人'
                    }]
                }]
            }
        },
        getData() {
            if (this.questionList.length) return
            getDefalutQuestionListApi().then(res => {
                if (res.data.code === 1000) {
                    this.questionList = res.data.data
                    let checkedArr = []
                    this.questionList.map(item => {
                        checkedArr.push(false)
                    })
                    this.checkedArr = checkedArr
                }
            }).catch(err => {
            })
            queryNations().then(res => {
                if (res.data.code === 1000) {
                    this.minorityList = []
                    res.data.data.forEach(item => {
                        this.minorityList.push({label: item.name, value: item.name})
                    })

                }
            })

            let loginInfo = JSON.parse(getStore('loginInfo_worker'))
            listBackstageUser({
                pageIndex: 1,
                pageSize: 1000,
                roleCode: "MEDIATOR"
            }).then(res => {
                if (res.data.code === 1000) {
                    res.data.data.list.forEach(item => {
                        if (item.orgId == loginInfo.userRoles[0].organizationId) {
                            this.mediatorOptions.push({
                                value: item.userId,
                                phone: item.mobilePhone,
                                label: item.userName
                            })
                        }
                    })
                }
            })
            listBackstageUser({
                pageIndex: 1,
                pageSize: 1000,
                roleCode: "CLERK"
            }).then(res => {
                if (res.data.code === 1000) {
                    res.data.data.list.forEach(item => {
                        if (item.orgId == loginInfo.userRoles[0].organizationId) {
                            this.clerkOptions.push({
                                value: item.userId,
                                phone: item.mobilePhone,
                                label: item.userName
                            })
                        }
                    })
                }
            })

            let that = this
            setTimeout(function () {
                if (loginInfo.userRoles && loginInfo.userRoles.length) {
                    let mediatorRole = loginInfo.userRoles.filter(item => {return item.roleCode == 'MEDIATOR'})
                    if (mediatorRole && mediatorRole.length) {
                        that.caseTypeform.mediator = loginInfo.userInfo.userId
                    } else {
                        let clerkRole = loginInfo.userRoles.filter(item => {return item.roleCode == 'CLERK'})
                        if (clerkRole && clerkRole.length) {
                            that.caseTypeform.clerk = loginInfo.userInfo.userId
                        }
                    }
                }
            }, 1000)
        },
        singleBoxChange(value,index){
            console.log('single----',value,index)
            this.checkedArr[index] = value
        },
        // 添加默认问题
        addCustomQuestion() {
            this.customQuestionList.push({ text: '' })
        },
        handleImport() {
            if (!this.importFilelist || this.importFilelist.length == 0) {
                this.$message.warning('请上传需要导入的xls、xlsx文件')
                return
            }

            this.BtnLoading = true
            let params = new FormData()
            params.append('uploadExcel', this.importFilelist[0].raw)
            if (this.importType == 1) {
                analysisPersonExcel(params).then(res=> {
                    this.BtnLoading = false
                    if (res.data.code === 1000) {
                        this.closeImportDialog()
                        let list = res.data.data
                        console.log('uploadExcel', list, this.allMember.attendantform)
                        this.allMember.attendantform = this.allMember.attendantform.concat(list)
                    } else if (res.data.message) {
                        this.$message.error(res.data.message)
                    }
                })
            } else if (this.importType == 2) {
                analysisExcel(params).then(res=> {
                    this.BtnLoading = false
                    if (res.data.code === 1000) {
                        this.closeImportDialog()
                        let list = res.data.data
                        if (list && list.length) {
                            list.forEach(item => {
                                this.customQuestionList.push({ text: item.questionContent, sort: item.sort })
                            })
                        }
                    } else if (res.data.message) {
                        this.$message.error(res.data.message)
                    }
                })
            }
        },
        handleExceed() {
            this.$message.warning('最多上传一个文件')
        },
        uploadSuccess(response, file, fileList) {
            this.importFilelist = fileList
        },
        // 删除默认问题
        deleteCustomQuestion(index) {
            this.customQuestionList.splice(index, 1)
        },
        showImportDialog(type) {
            this.importFilelist = []
            this.importType = type
            this.dialogVisible = true
        },
        closeImportDialog() {
            this.importFilelist = []
            this.dialogVisible = false
        },
        downloadTemplateFile() {
            if (this.importType == 1) {
                filedownload("/gzzc/docBook/clerkRecordDownload",{
                    fileId: 'Z3p6Y18zZDE2NmYzNjgwM2I0MTMwODkxY2I0ZjEzYzk1NWRjYQ==.xlsx',
                    id: 58830
                },"导入当事人模板.xlsx")
            } else if (this.importType == 2) {
                filedownload("/gzzc/docBook/clerkRecordDownload",{
                    fileId: 'Z3p6Y180OWRjMjdmMTMwNTg0NTAwOTUxYmM5YmQ4MDRkNmJhNw==.xlsx',
                    id: 57421
                },"导入问题单模板.xlsx")
            }
        },
        getFileName(data) {
            let fileName
            if(!data.substring(0,data.indexOf("."))){
                fileName = data
            } else {
                fileName = data.substring(0,data.indexOf("."))
            }
            return fileName
        },
        //获取材料分类
        getMaterailInfo() {
            getMaterailInfo({
                parentCode: 'MEDIATE_MATERIAL_TYPE'
            }).then(res => {
                if(res.data.code == ERR_OK){
                    this.filetypelist = res.data.data
                }
            },erro =>{

            })

        },

        //返回会议列表
        goMeetingList(){
            this.$router.go(-1)
        },
        currentTime () {
            let date = new Date(), datetime
            let ntostring = function(d){
                if(d.toString().length ==1){
                    return "0"+d;
                }
                return d;
            }
            if(new Date(this.timeform.orderDate).getTime()> date.getTime()){
                datetime = "00:00:00 - 23:59:59"
            }else {
                datetime = '"'+ntostring(date.getHours())+':'+ntostring(date.getMinutes()+2)+':'+ntostring(date.getSeconds())+'"'+' - '+'23:59:59'
                this.timeform.orderNewTime = new Date(date.getTime()+120000)
            }
            this.disabledTimeOptions = {'selectableRange':datetime, 'format':'HH:mm'}
        },
        // 材料分类
        changefiletype(val, index) {
            this.allFile.fileform[index].filetype = val;
        },
        // 删除材料
        delfileform(index) {
            this.allFile.fileform.splice(index, 1);
        },
        // 删除参会人员
        delAttendant(index) {
            this.allMember.attendantform.splice(index, 1);
        },
        fileremove(file, fileList, index) {
            this.allFile.fileform[index].filelist.splice(0, 1);
        },
        filesuccess(response, file, fileList, index) {
            if (response.code === 1000) {
                let fileobj = {
                    name: file.name,
                    id: response.data.fileId,
                }
                this.allFile.fileform[index].filelist.push(fileobj)
                // this.allFile.fileform[index].fileName = file.name
                // this.allFile.fileform[index].fileId = response.data.fileId
                this.allFile.fileform[index].sign = response.data.fileId
            }
        },
        handleBefore(file, accpet, obj) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            if (tempRet) {
                if (!~accpet.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + accpet + '等格式'
                });
                if (obj) {
                    obj.filelist = []
                }
                return false
            }

            this.flk.JWTToken = getStore('flk');
        },
        // 新增材料
        addfileform() {
            let fileobj = {
                    categoryBig: '',  //材料分类的名称
                    categorySmall: '',
                    categoryMiddle: '',
                    remark: '',
                    filelist: [],
                    showDelete: true,
                    disableFlag:false,
                };
            this.allFile.fileform.push(fileobj);
        },
        // 新增参会人员
        addAttendant() {
            if(this.allMember.attendantform.length<8){
                let fileobj = {
                    showDelete: true
                };
                this.allMember.attendantform.push(fileobj);
            } else {
                this.$message({
                message: '最多支持八个参会人员',
                type: 'warning'
                });
            }

        },
        goBack () {
            this.$router.go(-1)
        },
        async submitAllForm() {
            //校验会议类型
            let valiflag = true
            let msg = ''

            await this.$refs.typeform.validate((valid) => {
                if (!valid) {
                    valiflag = false;
                    msg = '案件类型表单不完整\n'
                    return false;
                }
            });
            if (this.caseTypeform.type == this.case_type_code.MEDIATION_MEETING) {
                //校验会议时间
                await this.$refs.timeform.validate((valid) => {
                    if (!valid) {
                        msg += '会议时间表单不完整\n'
                        valiflag = false;
                        return false;
                    }
                });
                //校验相关材料
                await this.$refs.allFile.validate((valid) => {
                    if (!valid) {
                        msg += '会议相关材料不完整\n'
                        valiflag = false;
                        return false;
                    }
                });
            }
            //校验参会人员
            await this.$refs.allMember.validate((valid) => {
                if (!valid) {
                    msg += this.caseTypeform.type == this.case_type_code.MEDIATION_MEETING? '参会人员' : '当事人' + '表单不完整\n'
                    valiflag = false;
                    return false;
                }
            });

            if (this.caseTypeform.type == this.case_type_code.ASYNCHRONOUS_TRIAL) {

                // 校验问题单序号是否有重复
                var ary = []
                this.embedQuestion.map( (item, index) => {
                    ary.push(item.sort)
                })
                this.questionList.map( (item, index) => {
                    if (this.checkedArr[index] && item.sort) ary.push(item.sort)
                })
                this.customQuestionList.map( (item, index) => {
                    if (item.text && item.sort) ary.push(item.sort)
                })
                var nary = ary.sort();
                for(var i=0; i<nary.length-1; i++) {
                    if (nary[i] == nary[i + 1]) {
                        msg += "问题单序号重复：" + nary[i]
                        valiflag = false;
                        break
                    }
                }
            }
            if (this.caseTypeform.type !== this.case_type_code.MEDIATION_MEETING) {
                if (this.caseTypeform.clerk && this.caseTypeform.mediator && this.caseTypeform.clerk == this.caseTypeform.mediator) {
                    valiflag = false;
                    msg += "\n书记员与仲裁员不可选择同一人"
                }
            }
            if (!valiflag) {
                this.$message.error(msg)
                return;
            } else {
                let attachFilesListTemp = [] , meetingTime = this.timeform.type == 'IMMEDIATELY_TYPE'?null:(new Date(this.timeform.orderDate+' '+this.timeform.orderNewTime).getTime())
                if(this.allFile.fileform && this.allFile.fileform.length){
                    this.allFile.fileform .forEach((element,index)=>{
                        if (element.filelist && element.filelist.length) {
                            let tempOption = {
                                categoryBig:'MEDIATION',
                                categorySmall: element.categorySmall,
                                categoryMiddle: element.categoryBig,
                                fileName: element.categoryMiddle || element.filelist[0].name,
                                remark: element.remark,
                                fileId: element.filelist[0].id,
                                sign: element.categoryBig
                            }
                            attachFilesListTemp.push(tempOption)
                        }
                    })
                }
                let params = {}
                if ( this.caseTypeform.type == this.case_type_code.MEDIATION_MEETING) {
                    params.caseId = null
                    params.meetingType = this.typeform.type
                    params.orderType = this.timeform.type
                    params.attachFilesList = attachFilesListTemp
                    params.name = this.caseTypeform.name
                    params.orderTime = meetingTime
                    params.meetingUserList = this.allMember.attendantform.filter(item => item.meetingUserType !== 'APPLICANT_COMPANY' && item.meetingUserType !== 'RESPONDENT_COMPANY')
                    if (this.caseTypeform.cause) {
                        params.causeCode = this.caseTypeform.cause
                        params.causeName = this.causeOptions.filter(item => item.value== this.caseTypeform.cause)[0].label
                    }
                    addmediationMeeting(params).then(res =>{
                        if(res.data.code == ERR_OK){
                            this.$router.push({
                                path: '/caseInHand'
                            });
                        } else if (res.data.message) {
                            this.$message.error(res.data.message)
                        }
                    })
                } else {
                    params.compList = []
                    params.agentList = []
                    params.userList = []
                    params.creatTime = new Date().getTime()
                    this.allMember.attendantform.forEach(item => {
                        if (item.meetingUserType == 'APPLICANT_AGENT' || item.meetingUserType == 'RESPONDENT_AGENT') {
                            params.agentList.push({
                                "caseAgentType":  item.meetingUserType=='APPLICANT_AGENT'? '申请人' : '被申请人',
                                "agentPhone": item.mobilePhone,
                                "agentType":"PRIVILEGE_AGENT",
                                "agentPosition": item.agentPosition,
                                "agentAddress": item.agentAddress,
                                "agentName": item.userName,
                                "agentIdCardType":"身份证",
                                "agentIdCard": item.idCard
                            })
                        } else if (item.meetingUserType == 'APPLICANT_COMPANY' || item.meetingUserType == 'RESPONDENT_COMPANY') {
                            params.compList.push({
                                "conName": item.conName,
                                "caseCompType": item.meetingUserType == 'APPLICANT_COMPANY'? '申请人' : '被申请人',
                                "compyId": '9999',
                                "phone": '',
                                "legalPerson": item.legalPerson,
                                "address": item.address,
                                "userType":"法人",
                                "ayCode":  this.caseTypeform.cause,
                                "ay": this.caseTypeform.cause? this.causeOptions.filter(item => item.value== this.caseTypeform.cause)[0].label : '',
                                "arbitrationClaim": item.arbitrationClaim
                            })
                        } else {
                            let user = {
                                "caseUserType": this.meetingTypeList.filter(type => type.value==item.meetingUserType)[0].label,
                                "idCard": item.idCard,
                                "userName": item.userName,
                                "minority": item.minority,
                                "sex": item.sex,
                                "birth": item.birth,
                                "address": item.address,
                                "phone": item.mobilePhone,
                                "userType":"自然人"
                            }

                            if (item.meetingUserType == 'APPLICANT') {
                                user.arbitrationClaim = item.arbitrationClaim
                            }
                            if (this.caseTypeform.cause) {
                                user.ayCode = this.caseTypeform.cause
                                user.ay = this.causeOptions.filter(item => item.value== this.caseTypeform.cause)[0].label
                            }
                            params.userList.push(user)
                        }
                    })

                    let zcy = this.mediatorOptions.filter(item => item.value == this.caseTypeform.mediator)[0]
                    let sjy = this.clerkOptions.filter(item => item.value == this.caseTypeform.clerk)[0]
                    params.stafList = [{
                        "zcyUserId": this.caseTypeform.mediator,
                        "zcy": zcy.label,
                        "zcyPhone": zcy.phone,
                        "sjyPhone": sjy.phone,
                        "sjyUserId":this.caseTypeform.clerk,
                        "sjy": sjy.label,
                        "mediator": "",
                        "sdy": sjy.label,
                        "sdyPhone": sjy.phone
                    }]

                    let loginInfo = JSON.parse(getStore("loginInfo_worker"));
                    let staffInfo = loginInfo.userRoles[0]
                    params.casList = [{
                        "user_case": this.caseTypeform.caseNo,
                        "disputeType": "",
                        "receiveDate": dateformat(new Date(), 'yyyy年MM月dd日'),
                        "mediate_case":"",
                        "caseNo":"",
                        "orgName": staffInfo.organizationName,
                        "orgId": "440101000000"
                    }]
                    params.mediationMeetingType = this.caseTypeform.type
                    params.meetingName = this.caseTypeform.caseNo
                    params.meetingUserList = this.allMember.attendantform.filter(item => item.meetingUserType !== 'APPLICANT_COMPANY' && item.meetingUserType !== 'RESPONDENT_COMPANY')
                    params.data = ""
                    params.code = "1"

                    if ( this.caseTypeform.type == this.case_type_code.ASYNCHRONOUS_TRIAL) {
                        // 问题单
                        params.questionList = []
                        this.questionList.forEach((item, index) => {
                            if (this.checkedArr[index] && item.sort) {
                                params.questionList.push({
                                    sort: item.sort,
                                    questionContent: item.addText? (item.addText + item.questionContent) : item.questionContent,
                                    questionType: item.questionType,
                                })
                            }
                        })
                        this.customQuestionList.forEach(item => {
                            if (item.sort && item.text)
                            params.questionList.push({
                                sort: item.sort,
                                questionContent: item.text,
                                questionType: 0,
                            })
                        })
                    }
                    addAsynchronousMeeting(params).then(res =>{
                        if(res.data.code == ERR_OK){
                            this.$router.push({
                                path: '/caseInHand'
                            });
                        } else if (res.data.message) {
                            this.$message.error(res.data.message)
                        }
                    })
                }
            }
        }
    },
    components:{
        // uploadfile
    }
}
</script>
<style lang="scss">
.reservateMeeting{
    .book-meeting{
        height: 60px;
        background: #fff;
        position: relative;
        color: #333333;
        padding-left: 40px;
        line-height: 60px;
        font-size: 16px;
        .meeting-arrow {
            cursor: pointer;
            left: 24px ;
            top:25px;
            position: absolute;
            display: inline-block;
            width: 10px;
            height: 10px;
            border-top: 2px solid #867f7a;
            border-right: 2px solid #867f7a;
            transform: rotate(-135deg);
            margin-right: -50px;
        }
    }
    .meeting-type {
        margin-top: 10px;
        height: 200px;
        background-color: #ffffff;
        .first-form {
            margin-top: 15px;
            .book-time-date {
                width: 900px;
                .el-form-item {
                    .el-form-item__label {
                        margin-right: 50px;
                    }
                }
            }
        }
    }
    .relation-meterail {
        margin-top: 10px;
        padding: 20px 0;
        background-color: #ffffff;
        .file-form {
            padding: 15px 10px 0;
            .el-form-item {
                margin: 0;
            }
            .hidden {
                visibility: hidden;
            }
            .fileupload {
                border: 1px solid #e7e7e7;
                border-radius: 4px;
                line-height: 38px;
                height: 38px;
                background-color: #fff;
                .el-upload-list {
                    width: 90%;
                    position: absolute;
                    left: 1px;
                    top: 1px;
                    background-color: #fff;
                    .el-progress {
                        display: none;
                    }
                    .el-upload-list__item:first-child {
                        margin-top: 0;
                    }
                    li {
                        line-height: 38px;
                        padding-left: 10px;
                        outline: none;
                        transition: inherit;
                        .el-icon-close {
                            font-size: 18px;
                            position: absolute;
                            right: 6px;
                            top: 10px;
                        }
                    }
                    .el-upload-list__item:hover {
                        background-color: #fff;
                    }
                    .el-upload-list__item.is-success .el-upload-list__item-name:hover {
                        color: #999;
                        cursor: default;
                    }
                }
                .el-upload {
                    width: 100%;
                    .el-button {
                        width: 100%;
                        display: block;
                        height: 38px;
                        line-height: 38px;
                        padding: 0;
                        background-color: #fff;
                        color: #666;
                        font-size: 13px;
                        border: none;
                    }
                    .el-button--primary:hover {
                        background: #fff;
                        box-shadow: none;
                    }
                }
            }
            .el-row {
                .widthauto{
                    width: 90%;
                }
                margin-bottom: 10px;
                padding: 10px 0 10px 12px;

            }
            .icon-name {
                display: flex;
                align-items: center;
                position: absolute;
                right: 18px;
                top: 20px;
                cursor: pointer;
                .el-icon-delete {
                    color: #0083c8;
                    font-size: 20px;
                    cursor: pointer;
                }
                .delete-name{
                    cursor: pointer;
                    font-size: 14px;
                }
            }
        }
    }
    .filebox-addtips {
        .addfile {
            &:hover  i{
                color:  #fff;
            }
            font-size: 14px;
            letter-spacing: 0px;
            color: #0083c8;
            text-align: center;
            width: 100px;
            margin: 0 auto;
            cursor: pointer;
            i {
                color:  #0083c8;
                font-size: 12px;
                padding-right: 5px;
                vertical-align: 1px;

            }
            .el-button {
                background-color: #fff;
                color: #0083c8;
                border: 1px solid #0083c8;
            }
            .el-button:hover {
                background-color: #0083c8;
                color: #fff;
            }
        }
        .tips {
            font-size: 12px;
            padding-top: 15px;
            color: #999;
            text-align: center;
        }
    }
    .questions-list {
        margin-top: 10px;
        min-height: 200px;
        padding-bottom: 20px;
        background-color: #ffffff;
        .custom-questions {
            background: #f6f7f9;
            border-radius: 4px;
            margin: 0 43px;
            padding: 20px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: center;
            .custom-question {
                width: 800px;
                height: 50px;
                display: flex;
                margin-right: 30px;
                flex-direction: row;
                align-items: center;
                .icon {
                    font-size: 24px;
                }
                .input {
                    width: 623px;
                    margin: 0 10px;
                }
            }
        }
    }
    .attendant-number {
        margin-top: 10px;
        min-height: 200px;
        padding-bottom: 20px;
        background-color: #ffffff;
        .attendant-form{
            padding: 20px 20px 0;
            .el-form-item {
                margin: 0;
                flex-grow: 1;
                .el-form-item__label {
                    padding: 0;
                }
            }
            .member_item {
                display: flex;
                align-items: center;
                background-color: #EFEFEF;
                border-radius: 4px;
                margin-bottom: 12px;
                padding: 20px 0;
                &.disabled {
                    .el-input__inner {
                        border: none;
                        background-color: transparent;
                        color: #333;
                        padding: 0;
                    }
                    .el-input__suffix {
                        display: none;
                    }
                }
                .el-form-item {
                    width: 25%;
                }
            }
            .icon-name {
                cursor: pointer;
                .el-icon-delete {
                    color: #0083c8;
                    font-size: 20px;
                    cursor: pointer;
                }
            }
        }
    }
    .type-tittle{
        padding-left: 24px;
        &:before{
            display: inline-block;
            position: relative;
            left:0;
            top:3px;
            content: '';
            width: 4px;
            height: 16px;
            background-image: linear-gradient(110deg,
                    #0083c8 0%,
                    #05c886 100%),
            linear-gradient(
                            #15c086,
                            #15c086);
            background-blend-mode: normal,
            normal;
        }
        line-height: 50px;
        height: 50px;
        border-bottom: 1px solid #e7e7e7;
        span {
            display: inline-block;
            margin-left: 10px;
            font-size: 16px;
            color: #333;
            span {
                color: #cccccc;
                font-size: 12px;
            }
        }
    }
    .footer {
        margin-top: 20px;
        width: 100%;
        height: 110px;
        background: #fff;
        text-align: center;
        line-height: 110px;
        display: flex;
        align-items: center;
        justify-content: center;
        .sumbmit-form{
            overflow: hidden;
            width: 300px;

            margin: 0 auto;
            .sumbit{
                width: 120px;
                height: 40px;
                float: left;
                line-height: 40px;
                font-size: 16px;
                color: #fff;
                margin-right: 15px;
                background-image: linear-gradient(110deg,
                    #0083c8 0%,
                    #05c886 100%),
                linear-gradient(
                    #0083c8,
                    #0083c8);
                background-blend-mode: normal,
                    normal;
                box-shadow: 0px 3px 7px 0px
                    rgba(76, 197, 156, 0.3);
                border-radius: 4px;
                cursor: pointer;
            }
            .concel{
                margin-left: 15px;
                width: 120px;
                height: 40px;
                color:  #0083c8;
                font-size: 16px;
                float: left;
                border-radius: 4px;
                border: solid 1px #0083c8;
                line-height: 40px;
                cursor: pointer;
                &:hover{
                    color:#fff;
                    background:  #0083c8;
                }
            }
        }
    }
}
</style>
